import React, { useState, useEffect, useMemo } from "react";
import single_0 from "../../images/baby/single/single_0.png";
import single_1 from "../../images/baby/single/single_1.png";
import single_2 from "../../images/baby/single/single_2.png";
import single_3 from "../../images/baby/single/single_3.png";
import single_4 from "../../images/baby/single/single_4.png";
import single_5 from "../../images/baby/single/single_5.png";
import single_6 from "../../images/baby/single/single_6.png";
import single_7 from "../../images/baby/single/single_7.png";
import single_8 from "../../images/baby/single/single_8.png";
import single_9 from "../../images/baby/single/single_9.png";
import single_10 from "../../images/baby/single/single_10.png";
import single_11 from "../../images/baby/single/single_11.png";
import single_12 from "../../images/baby/single/single_12.png";
import single_13 from "../../images/baby/single/single_13.png";
import single_14 from "../../images/baby/single/single_14.png";
import single_15 from "../../images/baby/single/single_15.png";
import single_16 from "../../images/baby/single/single_16.png";
import single_17 from "../../images/baby/single/single_17.png";
import single_18 from "../../images/baby/single/single_18.png";
import single_19 from "../../images/baby/single/single_19.png";
import single_20 from "../../images/baby/single/single_20.png";
import single_21 from "../../images/baby/single/single_21.png";
import single_22 from "../../images/baby/single/single_22.png";
import single_23 from "../../images/baby/single/single_23.png";
import single_24 from "../../images/baby/single/single_24.png";
import single_25 from "../../images/baby/single/single_25.png";
import single_26 from "../../images/baby/single/single_26.png";
import single_27 from "../../images/baby/single/single_27.png";
import single_28 from "../../images/baby/single/single_28.png";
import single_29 from "../../images/baby/single/single_29.png";
import single_30 from "../../images/baby/single/single_30.png";
import single_31 from "../../images/baby/single/single_31.png";
import single_32 from "../../images/baby/single/single_32.png";
import single_33 from "../../images/baby/single/single_33.png";
import single_34 from "../../images/baby/single/single_34.png";
import single_35 from "../../images/baby/single/single_35.png";
import single_36 from "../../images/baby/single/single_36.png";
import single_37 from "../../images/baby/single/single_37.png";
import single_38 from "../../images/baby/single/single_38.png";
import single_39 from "../../images/baby/single/single_39.png";
import single_40 from "../../images/baby/single/single_40.png";

import twins_1 from "../../images/baby/twins/twins_1.png";
import twins_2 from "../../images/baby/twins/twins_2.png";
import twins_3 from "../../images/baby/twins/twins_3.png";
import twins_4 from "../../images/baby/twins/twins_4.png";
import twins_5 from "../../images/baby/twins/twins_5.png";
import twins_6 from "../../images/baby/twins/twins_6.png";
import twins_7 from "../../images/baby/twins/twins_7.png"; 
import twins_8 from "../../images/baby/twins/twins_8.png";
import twins_9 from "../../images/baby/twins/twins_9.png";
import twins_10 from "../../images/baby/twins/twins_10.png";
import twins_11 from "../../images/baby/twins/twins_11.png";
import twins_12 from "../../images/baby/twins/twins_12.png";
import twins_13 from "../../images/baby/twins/twins_13.png";
import twins_14 from "../../images/baby/twins/twins_14.png";
import twins_15 from "../../images/baby/twins/twins_15.png";
import twins_16 from "../../images/baby/twins/twins_16.png";
import twins_17 from "../../images/baby/twins/twins_17.png";
import twins_18 from "../../images/baby/twins/twins_18.png";
import twins_19 from "../../images/baby/twins/twins_19.png";
import twins_20 from "../../images/baby/twins/twins_20.png";
import twins_21 from "../../images/baby/twins/twins_21.png";
import twins_22 from "../../images/baby/twins/twins_22.png";
import twins_23 from "../../images/baby/twins/twins_23.png";
import twins_24 from "../../images/baby/twins/twins_24.png";
import twins_25 from "../../images/baby/twins/twins_25.png";
import twins_26 from "../../images/baby/twins/twins_26.png";
import twins_27 from "../../images/baby/twins/twins_27.png";
import twins_28 from "../../images/baby/twins/twins_28.png";
import twins_29 from "../../images/baby/twins/twins_29.png";
import twins_30 from "../../images/baby/twins/twins_30.png";
import twins_31 from "../../images/baby/twins/twins_31.png";
import twins_32 from "../../images/baby/twins/twins_32.png";
import twins_33 from "../../images/baby/twins/twins_33.png";
import twins_34 from "../../images/baby/twins/twins_34.png";
import twins_35 from "../../images/baby/twins/twins_35.png";
import twins_36 from "../../images/baby/twins/twins_36.png";
import twins_37 from "../../images/baby/twins/twins_37.png";
import twins_38 from "../../images/baby/twins/twins_38.png";
import twins_39 from "../../images/baby/twins/twins_39.png";
import twins_40 from "../../images/baby/twins/twins_40.png";


const BabyImage = ({ babytype, babyweek }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState(null);

  const singleBabyImages = useMemo(() => [
    single_0, single_1, single_2, single_3, single_4, single_5, single_6, single_7, single_8, single_9,
    single_10, single_11, single_12, single_13, single_14, single_15, single_16, single_17, single_18, single_19,
    single_20, single_21, single_22, single_23, single_24, single_25, single_26, single_27, single_28, single_29,
    single_30, single_31, single_32, single_33, single_34, single_35, single_36, single_37, single_38, single_39,
    single_40,
  ], []);

  const twinBabyImages = useMemo(() => [
    twins_1, twins_2, twins_3, twins_4, twins_5, twins_6, twins_7, twins_8, twins_9, twins_10,
    twins_11, twins_12, twins_13, twins_14, twins_15, twins_16, twins_17, twins_18, twins_19, twins_20,
    twins_21, twins_22, twins_23, twins_24, twins_25, twins_26, twins_27, twins_28, twins_29, twins_30,
    twins_31, twins_32, twins_33, twins_34, twins_35, twins_36, twins_37, twins_38, twins_39, twins_40,
  ], []);

  useEffect(() => {
    setIsLoading(true);
    const img = new Image();
    
    // 쌍둥이의 경우 0주차 이미지가 없으므로 최소 1주차부터 시작
    const imageIndex = (babytype === "TWIN" || babytype === "twins") 
      ? Math.max(1, babyweek) - 1 
      : babyweek;  
    
    img.src = (babytype === "TWIN" || babytype === "twins") 
      ? twinBabyImages[imageIndex] 
      : singleBabyImages[imageIndex];

    img.onload = () => {
      setImageSrc(img.src);
      setIsLoading(false);
    };
  }, [babytype, babyweek, singleBabyImages, twinBabyImages]);

  if (isLoading) {
    return (
      <div className="w-[80%] flex items-center justify-center">
        <div className="w-[242px] h-[242px] md:w-[370px] md:h-[370px] bg-gray-100 animate-pulse rounded-full"></div>
      </div>
    );
  }

  return (
    <img
      src={imageSrc}
      alt="baby"
      className="w-[95%] md:w-[80%]"
    />
  );
};

export default BabyImage;
